/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

export { Centered } from '../common.style';

export const Description = styled.div`
  margin-top: ${gridSize()}px;
  text-align: center;
`;

export const ImageContainer = styled.div`
  margin-top: ${gridSize() * 5}px;
  width: ${gridSize() * 15}px;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  > img {
    width: 100%;
  }
`;
